import { ConnectedPositionStrategy } from '@angular/cdk/overlay';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PipelineManagementComponent } from '../../component/pipeline-management/pipeline-management.component'; 
import { CommonService } from '../../core/service/common-service/common.service';
import { PipelineEnquiryComponent } from '../pipeline-enquiry/pipeline-enquiry.component';

@Component({
  selector: 'app-lead-status-dialog',
  templateUrl: './lead-status-dialog.component.html',
  styleUrls: ['./lead-status-dialog.component.scss'],
})
export class LeadStatusDialogComponent implements OnInit {
  productNameValue: string;
  isClassTwoActive: boolean = true;
  isClassOneActive: boolean = true;
  isClassThreeActive: boolean = true;
  response: any;
  subResponse: any = null;
  responseArray: string[] = [];
  clickedRow: any;
  customerCode: any;
  vin: any;
  product: any;
  enquiryId: any;
  leadStatusCode: any;
  leadSubStatusCode: any;
  contractNumber: string;
  countryCode: any;
  userId: any;
  custResData: custData;
  followUpCount: any
  today: Date = new Date();
  followUpDate: any;
  enableUpdateButton: boolean = true;
  enquiryRemarks:string="";
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(private commonService: CommonService, private dialogRef: MatDialogRef<PipelineManagementComponent>, private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) public data: any, public router: Router) {
    this.clickedRow = JSON.parse(localStorage.getItem("pipelinecustomerData"));
    this.followUpCount = data.followUpCount;
  }

  ngOnInit() {
    this.userId = localStorage.getItem("userId");
    this.countryCode = localStorage.getItem("countryCode");
    if (this.followUpCount < 3) {
      this.enableUpdateButton = true;
    }
    else {
      this.enableUpdateButton = false;
    }

  }

  enableDropDown1(answer) {
    this.followUpDate = '';
    this.subResponse = "";
    this.contractNumber = "";
    this.response = answer.value;
    if (answer.value == "211" && this.enableUpdateButton == true) {
      return this.isClassOneActive = false;
    } else {
      return this.isClassOneActive = true;
    }
  }

  enableDropDown2(answer) {
    this.subResponse = "";
    this.response = answer.value;
    if (answer.value == "213") {
      return this.isClassTwoActive = false;
    } else {
      return this.isClassTwoActive = true;
    }
  }

  enableDropDown3(answer){
    if (answer.value == "212") {
      return this.isClassThreeActive = false;
    } else {
      return this.isClassThreeActive = true;
    }
  }

  followUpCheck() {
    if (this.followUpCount < 3) {
      this.enableUpdateButton = true;
    }
    else {
      this.enableUpdateButton = false;
      this.toastr.error("FollowUp must less than 3", "Error");

    }
  }


  onclose() {
    this.dialogRef.close(-1);
  }

  onSubmit() {
    this.saveResponse();
  }

  saveResponse(): void {
    if ((this.response == null || this.response == "") || (this.enquiryRemarks == null || this.enquiryRemarks == "")) {
      this.toastr.error("Please fill required fields");
    }else if(this.isClassOneActive == false && (this.followUpDate == null || this.followUpDate == "")){
      this.toastr.error("Please fill required fields");
    }
    else if(this.isClassOneActive == false  && (this.subResponse == null || this.subResponse == "")){
      this.toastr.error("Please Fill Required Fields.");
    }
    else if(this.isClassTwoActive == false  && (this.subResponse == null || this.subResponse == "")){
      this.toastr.error("Please Fill Required Fields.");
    }else if(this.isClassThreeActive == false && (this.contractNumber == null || this.contractNumber == "")){
      this.toastr.error("Please Fill Required Fields.");
    }
    else {
      this.custResData = new custData(
        this.customerCode = this.clickedRow.customerCode,
        this.vin = this.clickedRow.vin,
        this.product = this.clickedRow.productType,
        this.enquiryId = this.clickedRow.enquiryId,
        this.leadStatusCode = this.response,
        this.leadSubStatusCode = this.subResponse,
        this.userId,
        this.countryCode,
        this.followUpDate,
        this.contractNumber,
        this.enquiryRemarks

      )
      this.commonService.updatePipelineLeadStatus(this.custResData).subscribe(
        res => {
          if (res["responseCode"] == 0) {
            this.toastr.info(res["message"], "Success");
            this.onclose();
          }
          else {
            this.toastr.error(res["message"], "Error");
            this.onclose();
          }
        });
    }
  }

}

export function openLeadStatusDialog(dialog: MatDialog, clickedRow) {
  const config = new MatDialogConfig();
  config.disableClose = true;
  config.autoFocus = true;
  config.width = '720px';
  config.height = '350px';
  config.data = clickedRow;
  const dialogRef = dialog.open(LeadStatusDialogComponent, config);
  return dialogRef.afterClosed();

}

class custData {
  customerCode: string;
  vin: string;
  product: string;
  enquiryId: string;
  leadStatusCode: string;
  leadSubStatusCode: string;
  userId: string;
  countryCode: string;;
  followUpDate: string;
  contractNumber: string;
  enquiryRemarks: string;


  constructor(
    customerCode,
    vin,
    product,
    enquiryId,
    leadStatusCode,
    leadSubStatusCode,
    userId,
    countryCode,
    followUpDate,
    contractNumber,
    enquiryRemarks

  ) {
    this.customerCode = customerCode;
    this.vin = vin;
    this.product = product;
    this.enquiryId = enquiryId;
    this.leadStatusCode = leadStatusCode;
    this.leadSubStatusCode = leadSubStatusCode;
    this.userId = userId;
    this.countryCode = countryCode;
    this.followUpDate = followUpDate;
    this.contractNumber = contractNumber;
    this.enquiryRemarks = enquiryRemarks;

  }
}
